import './breadcrumbs.scss';

import React from 'react';

import { LocalizedLink } from '../localized-link';
import type { TBreadcrumbs } from './types';

interface IProps {
  breadcrumbs: TBreadcrumbs;
  className?: string;
}

const Breadcrumbs = ({ breadcrumbs, className }: IProps) => {
  return (
    <nav className={'breadcrumbs ' + (className || '')} aria-label="Breadcrumb">
      <ol className="breadcrumbs__list">
        {breadcrumbs.map((b, idx) => (
          <React.Fragment key={b.title}>
            {idx !== 0 && <span>/</span>}
            <li className="breadcrumbs__item">
              {idx < breadcrumbs.length - 1 ? (
                <LocalizedLink className="breadcrumbs__link" to={b.href}>
                  {b.title}
                </LocalizedLink>
              ) : (
                <span className="breadcrumbs__current" aria-current="page">
                  {b.title}
                </span>
              )}
            </li>
          </React.Fragment>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
